import { useLazyQuery } from "@apollo/client";
import { IPetInfoResponse } from "./pet-detail.interface";
import { GET_PET_INFO } from "./pet-detail.query";

export const usePetDetail = () => {
  const [petInfo, { loading, data, error }] = useLazyQuery<{ petInfoV2: IPetInfoResponse }>(GET_PET_INFO);

  const getPetInfo = (id: string) => {
    petInfo({
      variables: {
        id,
      },
      fetchPolicy: "cache-and-network",
    });
  };

  return {
    loading,
    getPetInfo,
    pet: data?.petInfoV2,
    error,
  };
};
